module.exports = __webpack_public_path__ + "media/images/weather/350_night-08f695c14ae012d6cb8228a46675c32a.png";